import { Activity } from '@cms-max/medicare-api-sdk'
import { UseChatEventConfig } from 'pubsub/hooks'

export const makeUnauthLoginEventCfg: (linkUrl: string) => UseChatEventConfig = (linkUrl) => {
  return {
    core: {
      activity: Activity.ButtonClick,
      coreClickData: {
        linkText: 'Log in & Chat',
        linkUrl
      },
      elementId: 'chat_unauthloginandchat_click'
    }
  }
}

export const makeUnauthRegisterEventCfg: (linkUrl: string) => UseChatEventConfig = (linkUrl) => {
  return {
    core: {
      activity: Activity.LinkClick,
      coreClickData: {
        linkText: 'Create an account',
        linkUrl
      },
      elementId: 'chat_unauthcreateaccount_click'
    }
  }
}

export const makeUnauthGuestChatEventCfg: (linkUrl?: string) => UseChatEventConfig = (linkUrl) => {
  return {
    core: {
      activity: Activity.ButtonClick,
      coreClickData: {
        linkText: 'Start Guest Chat',
        linkUrl
      },
      elementId: 'chat_unauthguestchat_click'
    }
  }
}

export const makeAuthChatEventCfg: (linkUrl?: string) => UseChatEventConfig = (linkUrl) => {
  return {
    core: {
      activity: Activity.ButtonClick,
      coreClickData: {
        linkText: 'Chat Now',
        linkUrl
      },
      elementId: 'chat_authchat_click'
    }
  }
}

export const popupBlockedEventCfg: UseChatEventConfig = {
  core: {
    activity: Activity.ButtonClick,
    coreClickData: {
      linkText: 'Your browser stopped the chat from opening. Adjust your settings and try again.'
    },
    elementId: 'chat_popupblocker_warning'
  }
}
